<template>
  <b-container class="p-0">
    <b-container class="d-flex flex-column align-items-start p-0">
      <slot name="header"> </slot>
    </b-container>

    <b-container class="grid__cards p-0">
      <router-link
        v-for="(item, index) in items"
        :key="`${item.id}-${index}`"
        :to="{
          name: 'micro-credentials/detail',
          params: { learningUnitId: item.id }
        }"
      >
        <LearningUnitCardItem
          :class="[...itemClass, 'h-100']"
          flush
          :learning-unit="item"
          @clickItem="clickItem"
        >
        </LearningUnitCardItem>
      </router-link>
    </b-container>
  </b-container>
</template>

<script>
import LearningUnitCardItem from './LearningUnitCardItem.vue';

export default {
  components: {
    LearningUnitCardItem
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    disabledItems: {
      type: Array,
      default: () => []
    },
    itemClass: {
      type: [String, Array, Object],
      default: ''
    },
    thumbnail: {
      type: String,
      default: '@/assets/default-lu-cover.jpg'
    },
    enableCursorPointer: {
      type: Boolean,
      default: true
    },
    showDetail: {
      type: Boolean,
      default: true
    },
    defaultClass: {
      type: String,
      default: 'd-flex flex-column flex-sm-row align-items-start mt-2 mb-2'
    }
  },

  data() {
    return {
      fetching: false
    };
  },

  computed: {
    itemLength() {
      return this.items && this.items.length ? this.items.length : 0;
    },
    disabledItemLength() {
      return this.disabledItems && this.disabledItems.length ? this.disabledItems.length : 0;
    }
  },

  methods: {
    clickItem(item) {
      this.$emit('clickItem', item);
    }
  }
};
</script>

<style lang="scss" scoped>
.grid__cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(352px, 1fr));
  gap: 2.5rem;
  justify-content: center;
}

/* Large devices (desktops, 992px and up) */
@media screen and (max-width: 1199px) {
  .grid__cards {
    grid-template-columns: repeat(3, minmax(282px, 1fr));
  }
}

/* Medium devices (tablets, 768px to 991px) */
@media screen and (max-width: 991px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(332px, 1fr));
  }
}

/* Extra small devices (portrait phones, less than 576px) */
@media screen and(max-width: 767px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(264px, 1fr));
    gap: 1rem;
  }
}
@media screen and (max-width: 575px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(163px, 1fr));
    gap: 1rem;
  }
}
@media screen and (max-width: 374px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(130px, 1fr));
    gap: 1rem;
  }
}
</style>
